/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TOTPRegisterAttestationData
 */
export interface TOTPRegisterAttestationData {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterAttestationData
     */
    otp?: string;
}

/**
 * Check if a given object implements the TOTPRegisterAttestationData interface.
 */
export function instanceOfTOTPRegisterAttestationData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TOTPRegisterAttestationDataFromJSON(json: any): TOTPRegisterAttestationData {
    return TOTPRegisterAttestationDataFromJSONTyped(json, false);
}

export function TOTPRegisterAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterAttestationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'otp': !exists(json, 'otp') ? undefined : json['otp'],
    };
}

export function TOTPRegisterAttestationDataToJSON(value?: TOTPRegisterAttestationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'otp': value.otp,
    };
}

